import { NgClass } from '@angular/common';
import { inject, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { MenuData, MenuItem } from './types';

import { SvgIcon } from '../../ui/svg-icon';
import { MENU_DATA } from './menu-injectors';

@Component({
  selector: 'app-menu',
  imports: [NgClass, SvgIcon],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  host: {
    class: 'menu',
    '[class]': 'menuClass',
  },
})
export class Menu {
  public menuData = inject<MenuData>(MENU_DATA);

  menuClass?: string | string[] | Set<string> | Record<string, any>;

  onMenuItemClick(menuItem: MenuItem) {
    this.menuData.closeHandler();

    menuItem.action(this.menuData.context);
  }
}
